'use client';

import Icon from './Icon';
import svg from 'sprites/done.svg';

export default function IconDone({
  className = 'w-[35px] h-[35px] fill-sand-dark stroke-white'
}: {
  className?: string;
}) {
  return <Icon id={svg.id} className={className} />;
}
